import React from 'react';
import { Next, Previous } from '../icons';

const ImageSliderArrow = (props) => {
    return (
        <div className={`slider-arrow ${props.direction}`} onClick={() => props.handleArrowScroll(props.direction)}>
            {props.direction == 'left' &&
                <Previous />
            }
            {props.direction == 'right' &&
                <Next />
            }
        </div >
    )
}

export default ImageSliderArrow;


// WEBPACK FOOTER //
// ./src/components/common/image-slider/image-slider-arrow.jsx